import script from "./MarketplaceReservations.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketplaceReservations.vue?vue&type=script&setup=true&lang=ts"

import "./MarketplaceReservations.vue?vue&type=style&index=0&id=c6a1cdec&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6a1cdec"]])

export default __exports__